import { CircularProgress, styled } from "@mui/material";

const Wrapper = styled("div")({
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  margin: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
});

export const LoadingIndicator = ({ label }) => (
  <Wrapper>
    <CircularProgress color="accent3Color" size={100} />
    {label && <p>{label}</p>}
  </Wrapper>
);
